"use client";

import { Button } from "@frontend/shared/components/ui/button";
import { cn } from "@frontend/shared/lib/utils";

export function QuestionnaireButton({
  buttonText,
  buttonStyle,
  onOpenModal,
}: {
  buttonText: string;
  buttonStyle?: string;
  onOpenModal: () => void;
}) {
  return (
    <Button
      onClick={onOpenModal}
      data-testid={`questionnaire-button-${buttonText}`}
      className={cn(
        "rounded-full p-4 text-lg h-12 text-center text-black bg-white hover:bg-white/80",
        buttonStyle,
      )}
    >
      {buttonText}
    </Button>
  );
}
